import { checkHowManyIsAvailableForRent, findWarehouse } from 'containers/Playground/utils/warehouse'
import { selectPlaceShowDifferentSizeOnMap } from 'containers/MapDetails/placeSlice'
import { selectPlaygroundWarehouses } from '../../playgroundSlice'
import { followObject } from 'containers/Playground/utils/cloud'
import { useHistory, useLocation } from 'react-router-dom'
import useTranslation from 'hooks/useTranslation'
import { displayPrice } from 'utils/string'
import { useReduxSelector } from 'store'
import React from 'react'

interface WarehouseCloudProps {
  typeId: string
  object: HTMLElement
}

const WarehouseCloud: React.FC<WarehouseCloudProps> = ({ typeId, object }) => {
  const warehouses = useReduxSelector(selectPlaygroundWarehouses)
  const warehouse = findWarehouse(typeId, warehouses)
  const isLastForRent = checkHowManyIsAvailableForRent(warehouses) === 1
  return (
    <div
      ref={followObject(object)}
      className='playground__cloud'>
      {warehouse
        ? <WarehouseCloudBody
          isLastForRent={isLastForRent}
          warehouse={warehouse}
        />
        : <div className='playground__cloud__head'>
          <span className='playground__cloud__name'>Nie znaleziono obiektu</span>
        </div>}
    </div>
  )
}

interface WarehouseCloudBodyProps {
  warehouse: playground.Warehouse
  isLastForRent?: boolean
}

const WarehouseCloudBody: React.FC<WarehouseCloudBodyProps> = ({ warehouse, isLastForRent }) => {
  const { id } = useParams()
  const isSelected = id === warehouse.typeId
  const showDifferentSize = useReduxSelector(selectPlaceShowDifferentSizeOnMap)

  const { t } = useTranslation('placeMap')
  const { goBack } = useHistory()

  const isRentable = warehouse.color_state === 'view_for_rent' && !!warehouse.warehouseData?.status?.isAvailableForRent
  const showLastForRent = isLastForRent && isRentable

  return (
    <>
      {(warehouse.name || warehouse.warehouseData?.size?.area) && <div className='playground__cloud__head'>
        {warehouse.warehouseData?.size?.area && <span className='playground__cloud__name'>{warehouse.warehouseData.size.area} m<sup>2</sup></span>}
        <span className='playground__cloud__area'>Nr. {warehouse.name}</span>
      </div>}
      {showLastForRent && <div className='playground__cloud__badge'>
        <i className='icon icon--fire-bold' />
        <span>{t('lastOneOfThisSize')}</span>
      </div>}
      <div className='playground__cloud__actions'>
        {isRentable
          ? <button
            className={`button ${isSelected ? ' --selected' : ''}`}
            onClick={() => {
              if (isSelected) goBack()
            }}>
            {t(isSelected ? 'selected' : 'select')}{warehouse.warehouseData?.attributes?.monthlyGrossPrice ? ` · ${displayPrice(warehouse.warehouseData?.attributes?.monthlyGrossPrice)} / ${t('monthShort')}` : ''}
          </button>
          : (warehouse.warehouseData?.status?.isAvailableForRent && showDifferentSize)
            ? <button className='button'>
              {t('differentSize')}
            </button>
            : <button className='button'>
              {t('warehouseIsUnavailable')}
            </button>}
      </div>
    </>
  )
}

const useParams = () => {
  const { pathname } = useLocation()
  const pathnameList = pathname.split('/')
  return {
    id: pathnameList[3],
    placeId: pathnameList[2],
  }
}

export default WarehouseCloud